import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19.982} height={20} {...props}>
    <g data-name="Puzzles 20">
      <path
        data-name="Path 7736"
        d="M4.294 15.198a3.172 3.172 0 0 1-3.735-1.269 3.093 3.093 0 0 1 .01-3.559 3.2 3.2 0 0 1 3.725-1.262V5.836a1.426 1.426 0 0 1 1.52-1.522H9.09A3.169 3.169 0 0 1 10.405.559a2.976 2.976 0 0 1 3.516.034 3.14 3.14 0 0 1 1.256 3.721h3.277a1.429 1.429 0 0 1 1.528 1.533v4.432a.753.753 0 0 1-.431.783.738.738 0 0 1-.85-.2 1.779 1.779 0 0 0-2.818 2.052 1.8 1.8 0 0 0 2.812.534.82.82 0 0 1 .658-.261.718.718 0 0 1 .626.768v4.611a1.414 1.414 0 0 1-1.432 1.427c-1.537.007-3.073 0-4.611 0a.72.72 0 0 1-.529-1.252 1.779 1.779 0 1 0-2.676-2.334 1.761 1.761 0 0 0 .1 2.288.812.812 0 0 1 .275.674.7.7 0 0 1-.682.618c-1.6.006-3.193.015-4.789 0a1.388 1.388 0 0 1-1.333-1.405c-.01-1.047 0-2.094 0-3.14v-.246Z"
        fill="#00bce8"
      />
      <path
        data-name="Path 7738"
        d="M19.98 17.922v.646a1.414 1.414 0 0 1-1.432 1.427c-1.537.007-3.073 0-4.61 0a.72.72 0 0 1-.53-1.252 1.779 1.779 0 1 0-2.676-2.333 1.761 1.761 0 0 0 .1 2.288.812.812 0 0 1 .276.674.7.7 0 0 1-.682.618c-1.468.006-2.938.014-4.406 0a39.752 39.752 0 0 0 9.76-15.68h2.677a1.429 1.429 0 0 1 1.528 1.534v4.432a.753.753 0 0 1-.432.783.737.737 0 0 1-.85-.2 1.779 1.779 0 0 0-2.818 2.053 1.8 1.8 0 0 0 2.813.534.817.817 0 0 1 .659-.261.717.717 0 0 1 .625.768v3.965Z"
        fill="#00a4e5"
      />
    </g>
  </svg>
);

export default SvgComponent;
